const jQuery = require("jquery");

window.$ = window.$ || jQuery;
window.jQuery = window.jQuery || jQuery;

require("jquery-ujs");
require("bootstrap-v3/assets/javascripts/bootstrap/collapse");
require("bootstrap-v3/assets/javascripts/bootstrap/modal");
require("bootstrap-v3/assets/javascripts/bootstrap/tooltip");
require("bootstrap-v3/assets/javascripts/bootstrap/popover");
require("bootstrap-v3/assets/javascripts/bootstrap/dropdown");
require("lazysizes/lazysizes.min");

// eslint-disable-next-line global-require
window.$lightbox = window.$lightbox || require("lightbox2");

window.JiffyApi = require("jiffy-api");
window.JiffyStore = require("jiffy-store");
window.JiffyAnalytics = require("jiffy-analytics");

(function module(root, factory) {
  factory(jQuery);
})(this, _$ => {
  // allow customization for lightbox
  window.$lightbox.option({
    alwaysShowNavOnTouchDevices: true
  });
});

module.exports = jQuery;
